import type { WebshopRemoveFromCartButton } from "./types/types";

export const createWebshopRemoveFromCartButton =
  (): WebshopRemoveFromCartButton => {
    const event: WebshopRemoveFromCartButton = {
      event: "Webshop Remove from Cart Button",
    };
    return event;
  };
